import React, { useEffect, useState } from 'react';
import { apiFetch } from "../../../../apiFetch";
import './TrainingVideos.css';

const CHANNELS = {
    trainingVideos: {
        id: 'UC82ALhXKYfX4BtDrzm8oM3A',
        label: 'Training Videos'
    },
    vsnWorld: {
        id: 'UCwXdRTjP4RO3TFNfEEafDKw',
        label: 'VSN World'
    }
};

const DISCLAIMER_LIMIT = 10;

const TrainingVideos = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    const userId = user?.id;

    const [videos, setVideos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedTab, setSelectedTab] = useState('trainingVideos');
    const [disclaimer, setDisclaimer] = useState('');

    const fetchVideosFromDB = async (channelId) => {
        setLoading(true);
        setError(null);
        try {
            const res = await apiFetch(
                `/videos?channelId=${encodeURIComponent(channelId)}`
            );


            if (!res.ok) {
                const text = await res.text().catch(() => "");
                throw new Error(`Failed to load videos (${res.status}): ${text}`);
            }

            const data = await res.json();
            setVideos(Array.isArray(data) ? data : []);

        } catch (err) {
            console.error('Failed to load videos from DB:', err);
            setError('Failed to load videos.');
        } finally {
            setLoading(false);
        }
    };

    const getDisclaimerCount = (tabKey) => {
        return parseInt(localStorage.getItem(`disclaimerCount_${tabKey}`)) || 0;
    };

    const incrementDisclaimerCount = (tabKey) => {
        const currentCount = getDisclaimerCount(tabKey);
        localStorage.setItem(`disclaimerCount_${tabKey}`, currentCount + 1);
    };

    useEffect(() => {
        const { id: channelId } = CHANNELS[selectedTab];
        fetchVideosFromDB(channelId);

        const currentCount = getDisclaimerCount(selectedTab);

        if (currentCount < DISCLAIMER_LIMIT) {
            const newDisclaimer =
                selectedTab === 'trainingVideos'
                    ? 'Subscribe to this channel for top Football training content in collaboration with experts...'
                    : 'Subscribe to this channel to get updated when trials come to your area.....';

            setDisclaimer(newDisclaimer);
            incrementDisclaimerCount(selectedTab);

            const timer = setTimeout(() => setDisclaimer(''), 3000);
            return () => clearTimeout(timer);
        } else {
            setDisclaimer('');
        }
    }, [selectedTab]);

    return (
        <div className="training-videos">
            <h2>Training Videos</h2>

            {userId && <p style={{ fontSize: '12px', color: 'gray' }}>User ID: {userId}</p>}

            <div className="tab-toggle">
                {Object.entries(CHANNELS).map(([key, { label }]) => (
                    <button
                        key={key}
                        className={selectedTab === key ? 'active' : ''}
                        onClick={() => setSelectedTab(key)}
                    >
                        {label}
                    </button>
                ))}
            </div>

            {disclaimer && (
                <div className="disclaimer">{disclaimer}</div>
            )}

            {loading && <p>Loading...</p>}
            {error && <p className="error">{error}</p>}

            {!loading && !error && (
                <div className="video-list">
                    {videos.map((video, index) => (
                        <div key={index} className="video-card">
                            <div className="video-title">{video.title}</div>
                            <div className="video-description">{video.description}</div>
                            <iframe
                                className="video-player"
                                src={video.embedUrl}
                                title={video.title}
                                allowFullScreen
                            ></iframe>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default TrainingVideos;








